import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';

import { GetHealthProfileDataProps } from 'services/healthProfile/healthProfile.types';

import { HealthProfileState } from './healthProfile.types';

const initialState: HealthProfileState = {
  medicalIntake: {
    additionalHealthConditions: [],
    allergyList: [],
    chronicDiseases: [],
    healthConditions: [],
    medications: { prescription: [], supplements: [] },
    preferredPharmacy: '',
    socialHistory: [],
    womenHealth: {
      approxStartDate: '',
      name: '',
      startDate: ''
    }
  },
  mifDetails: {
    id: '',
    status: 'mif-normal'
  }
};

const healthProfileSlice = createSlice({
  initialState,
  name: 'healthProfile',
  reducers: {
    setHealthProfile: (state, action: PayloadAction<Partial<GetHealthProfileDataProps>>) => {
      state.medicalIntake = { ...state.medicalIntake, ...action.payload.medicalIntake };
      state.mifDetails = { ...state.mifDetails, ...action.payload.mifDetails };
      if (action.payload.healthConditionsOptions) {
        state.healthConditionsOptions = action.payload.healthConditionsOptions;
      }
    }
  }
});

export const { setHealthProfile } = healthProfileSlice.actions;

export const selectHealthProfile = (state: RootState) => state.healthProfile;

export default healthProfileSlice.reducer;
